<template>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>库存列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">

          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="stocks" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <!--
      <el-table-column label="图片">
        <template #default="scope">
          <img :src="$utils.imageSrc(scope.row.pic)"/>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '油品' : '物料'}}
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template #default="scope">
          {{scope.row.quantity + scope.row.unit}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showDetail(scope.row)">记录</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog title="记录" v-model="detailVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-table :data="details" border>
      <el-table-column prop="createDate" label="时间"></el-table-column>
      <el-table-column label="数量">
        <template #default="scope">
          {{scope.row.quantity}}
        </template>
      </el-table-column>
      <el-table-column prop="billNo" label="单号"></el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="detailPageIndex" @size-change="handleSizeChange"
                   :page-size="detailPageSize" :total="detailTotal" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </el-dialog>
</template>

<script>
export default {
  name: "库存",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      stocks: [],
      detailVisible: false,
      detailSn: null,
      detailPageIndex: 1,
      detailPageSize: 10,
      detailTotal: 0,
      details: []
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.store.stockList(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.stocks = response.data.data
        this.total = response.data.total
      })
    },
    stockDetailList(pageIndex) {
      if (pageIndex) {
        this.detailPageIndex = pageIndex
      }
      this.$apis.store.stockDetailList(this.detailPageIndex - 1, this.detailPageSize, this.detailSn).then(response => {
        this.details = response.data.data
        this.detailTotal = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      if (!this.detailVisible) {
        this.pageIndex = pageIndex
        this.list()
      } else {
        this.detailPageIndex = pageIndex
        this.stockDetailList()
      }
    },
    handleSizeChange(pageSize) {
      if (!this.detailVisible) {
        this.pageSize = pageSize
        this.list(1)
      } else {
        this.detailPageSize = pageSize
        this.stockDetailList(1)
      }
    },
    showDetail(detail) {
      this.detailVisible = true
      this.detailSn = detail.sn
      this.stockDetailList(1)
    }
  },
  created() {
    if (this.currentUser.type === 1 || this.currentUser.type === 0) {
      this.queryParam.companySn = this.currentUser.sn
    }
    this.list()
  }
}
</script>

<style scoped>

</style>